export default "__VITE_ASSET__BEzsbgsn__"